import { minify } from 'terser';

export const complete_purchase = ({ outcomeLid }) => /* html */ `
<script>
(function (j) {
var l='${outcomeLid}', s, d, w, e = encodeURIComponent, d = document, w = window.location, p = d.createElement("IMG");
s = w.protocol + '//tvspix.com/t.png?t=' + (new Date()).getTime() + '&l=' + l + '&u3=' + e(w.href) + '&u1=complete_purchase&u2=' + j.orderAmount + '&u4=' + e(j.orderId) + '&u5=' + e(j.lastTouchChannel) ;
p.setAttribute("src", s); p.setAttribute("height", "0"); p.setAttribute("width", "0"); p.setAttribute("alt", ""); p.style.display = 'none'; p.style.position = 'fixed'; d.body.appendChild(p);
})({
  orderId: "{{OrderId}}", 	 // required
  orderAmount: "{{Amount}}", // required, pretax, preshipping, postdiscount
  lastTouchChannel: ""       // optional
})
</script>

`;

export const add_to_cart = ({ outcomeLid }) => /* html */ `
<script>
(function (j) {
  var l='${outcomeLid}', s, d, w, e = encodeURIComponent, d = document, w = window.location, p = d.createElement("IMG");
  s = w.protocol + '//tvspix.com/t.png?t=' + (new Date()).getTime() + '&l=' + l + '&u3=' + e(w.href) + '&u1=add_to_cart&u4=' + (new Date()).getTime() + '&u5=' + e(j.lastTouchChannel);
  p.setAttribute("src", s); p.setAttribute("height", "0"); p.setAttribute("width", "0"); p.setAttribute("alt", ""); p.style.display = 'none'; p.style.position = 'fixed'; d.body.appendChild(p);
})({
  lastTouchChannel: "", // optional
})
</script>
`;

export const start_checkout = ({ outcomeLid }) => /* html */ `
<script>
(function (j) {
  var l='${outcomeLid}', s, d, w, e = encodeURIComponent, d = document, w = window.location, p = d.createElement("IMG");
  s = w.protocol + '//tvspix.com/t.png?t=' + (new Date()).getTime() + '&l=' + l + '&u3=' + e(w.href) + '&u1=start_checkout&u4=' + (new Date()).getTime() + '&u5=' + e(j.lastTouchChannel);
  p.setAttribute("src", s); p.setAttribute("height", "0"); p.setAttribute("width", "0"); p.setAttribute("alt", ""); p.style.display = 'none'; p.style.position = 'fixed'; d.body.appendChild(p);
})({
  lastTouchChannel: "", // optional
})
</script>
`;

export const keyword_search = ({ outcomeLid }) => /* html */ `
<script>
(function (j) {
    var l='${outcomeLid}', s, d, w, e = encodeURIComponent, d = document, w = window.location, p = d.createElement("IMG");
    s = w.protocol + '//tvspix.com/t.png?t=' + (new Date()).getTime() + '&l=' + l + '&u3=' + e(w.href) + '&u1=keyword_search&u4=' + (new Date()).getTime() + '&u5=' + e(j.lastTouchChannel);
    p.setAttribute("src", s); p.setAttribute("height", "0"); p.setAttribute("width", "0"); p.setAttribute("alt", ""); p.style.display = 'none'; p.style.position = 'fixed'; d.body.appendChild(p);
})({
  lastTouchChannel: "{{Last Touch Channel}}",
  note: "{{keyword}}",
})
</script>
`;

export const viewed_product = ({ outcomeLid }) => /* html */ `
<script>
(function (j) {
  var l='${outcomeLid}', s, d, w, e = encodeURIComponent, d = document, w = window.location, p = d.createElement("IMG");
  s = w.protocol + '//tvspix.com/t.png?t=' + (new Date()).getTime() + '&l=' + l + '&u3=' + e(w.href) + '&u1=viewed_product&u4=' + (new Date()).getTime() + '&u5=' + e(j.lastTouchChannel);
  p.setAttribute("src", s); p.setAttribute("height", "0"); p.setAttribute("width", "0"); p.setAttribute("alt", ""); p.style.display = 'none'; p.style.position = 'fixed'; d.body.appendChild(p);
})({
  lastTouchChannel: "", // optional
})
</script>
`;

export const lead_generated = ({ outcomeLid }) => /* html */ `
<script>
(function (j) {
  var l='${outcomeLid}', s, d, w, e = encodeURIComponent, d = document, w = window.location, p = d.createElement("IMG");
  s = w.protocol + '//tvspix.com/t.png?t=' + (new Date()).getTime() + '&l=' + l + '&u3=' + e(w.href) + '&u1=lead_generated&u4=' + e(j.orderId) + '&u5=' + e(j.lastTouchChannel);
  p.setAttribute("src", s); p.setAttribute("height", "0"); p.setAttribute("width", "0"); p.setAttribute("alt", ""); p.style.display = 'none'; p.style.position = 'fixed'; d.body.appendChild(p);
})({
  orderId: "{{Lead Id}}", 	// required
  lastTouchChannel: "",     // optional
})
</script>
`;

export const trial_started = ({ outcomeLid }) => /* html */ `
<script>
(function (j) {
    var l='${outcomeLid}', s, d, w, e = encodeURIComponent, d = document, w = window.location, p = d.createElement("IMG");
    s = w.protocol + '//tvspix.com/t.png?t=' + (new Date()).getTime() + '&l=' + l + '&u3=' + e(w.href) + '&u1=trial_started&u4=' + e(j.orderId) + '&u5=' + e(j.lastTouchChannel) + '&u6=' + e(j.customerId) + '&u12=' + e(j.note);
    p.setAttribute("src", s); p.setAttribute("height", "0"); p.setAttribute("width", "0"); p.setAttribute("alt", ""); p.style.display = 'none'; p.style.position = 'fixed'; d.body.appendChild(p);
})({
  orderId: "{{Event Id}}",   /*required */
  customerId: "{{CustomerId}}",
  note: "{{Note}}",
  lastTouchChannel: "{{Last Touch Channel}}",
})
</script>
`;

export const complete_registration = ({ outcomeLid }) => /* html */ `
<script>
(function (j) {
  var l='${outcomeLid}', s, d, w, e = encodeURIComponent, d = document, w = window.location, p = d.createElement("IMG");
  s = w.protocol + '//tvspix.com/t.png?t=' + (new Date()).getTime() + '&l=' + l + '&u3=' + e(w.href) + '&u1=complete_registration&u4=' + e(j.orderId) + '&u5=' + e(j.lastTouchChannel);
  p.setAttribute("src", s); p.setAttribute("height", "0"); p.setAttribute("width", "0"); p.setAttribute("alt", ""); p.style.display = 'none'; p.style.position = 'fixed'; d.body.appendChild(p);
})({
  orderId: "{{Registration Id}}", // required
  lastTouchChannel: "",           // optional
})
</script>
`;

export const complete_purchase_shopify = ({ outcomeLid }) => /* html */ `
{% if first_time_accessed %}
<script>
var customerStatus = "NEW", discountper=0;

{% if checkout.discounts.size > 0 %}
discountper =   ({{checkout.discounts_amount | money_without_currency }} / ({{ total_price | money_without_currency }} -  {{ shipping_price | | money_without_currency }} +{{checkout.discounts_amount | money_without_currency }} ))
{% endif %}

{% if order.customer.orders_count > 1 %}
    customerStatus = "RETURNING";
{% endif %}
var items = [];

{% for item in line_items %}

    lineItem = {

      SKU: "{{ item.sku }}",
      CAT: "{{ item.product.title | replace: '"','"' }}",
      QTY: "{{ item.quantity }}",
      PR: {{ item.final_price | money_without_currency }}*(1-discountper)

    };

 items.push(lineItem);

{% endfor %}

(function (j) {
var l='${outcomeLid}', s, d, w, e = encodeURIComponent, d = document, w = window.location, p = d.createElement("IMG");
s = w.protocol + "//tvspix.com/t.png?t=" + (new Date()).getTime() + "&l=" + l + "&u3=" + e(w.href) + "&u1=complete_purchase&u2=" + e(j.orderAmount) + "&u4=" + e(j.orderId) + "&u6=" + e(j.customerId) + "&u8=" + e(j.customerStatus) + "&u13=" + e(JSON.stringify(j.items)) + "&u14=" + e(j.promoCode) + "&u15=" + j.currency + "&u11=Shopify";
p.setAttribute("src", s); p.setAttribute("height", "0"); p.setAttribute("width", "0"); p.setAttribute("alt", ""); p.style.display = 'none'; p.style.position = 'fixed'; d.body.appendChild(p);
})({
		orderId: "{{ order_id }}", 	//required
		orderAmount: "{{ subtotal_price | money_without_currency }}",
		currency: "USD",
		customerId: "{{ order.customer.id }}",
		customerStatus: customerStatus,
		promoCode: "{{ checkout.discounts[0].code }}",
		items: items
	 })
</script>
{% endif %}
`;

export const gtm_tvci = ({ outcomeLid }) => /* html */ `
<script async src="https://www.googletagmanager.com/gtag/js?id={{GA4 Measurement ID}}"></script>
<script>
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', '{{GA4 Measurement ID}}', {
  name: 'tvScientific',
  transport_url: 'https://proxy.tvsci.net',
  custom_map: {
    dimension1: 'tvsci_exp'
  },
  send_page_view: false
});
gtag('event', 'page_view', {
  tvsci_exp: '${outcomeLid}',
  transport_url: 'https://proxy.tvsci.net',
  non_interaction: true
});
</script>
`;

export const universal_pixel = ({ outcomeLid }) => /* html */ `
<script type="text/javascript">
(function () {var p, s, d, w;d = document;w = window.location;p = d.createElement("IMG");s = w.protocol + "//tvspix.com/t.png?&t=" + (new Date).getTime() + "&l=${outcomeLid}&u3=" + encodeURIComponent(w.href);p.setAttribute("src", s);p.setAttribute("height", "0");p.setAttribute("width", "0");p.setAttribute("alt", "");p.style.setProperty("display", "none");p.style.setProperty("position", "absolute");p.style.setProperty("visibility", "hidden");d.body.appendChild(p);})();
</script>
`;

export const generic_pixel = ({ outcomeLid }) => /* html */ `
<script type="text/javascript">
  (function () {
    var p, s, d, w;d = document;w = window.location;p = d.createElement("IMG");
    s = w.protocol + "//tvspix.com/t.png?&t=" + (new Date).getTime() + "&l=${outcomeLid}&u3=" + encodeURIComponent(w.href) + "&u1=keyword_search22&u2=&u5={{Referral Source}}";
    p.setAttribute("src", s);p.setAttribute("height", "0");p.setAttribute("width", "0");p.setAttribute("alt", "");p.style.setProperty("display", "none");p.style.setProperty("position", "absolute");p.style.setProperty("visibility", "hidden");d.body.appendChild(p);
  })();
</script>
`;

// Full unminified code for this lives in repo: https://github.com/tvScientific/tvs-pixel-firing-script
// DO NOT update this code directly.
export const ga4 = ({ outcomeLid, measurementId }) => /* html */ `
<script>
  var observer,pixelFired=!1,userMeasurementId="${measurementId}";function getGA4SessionId(){for(var e=document.cookie.split(";"),t=userMeasurementId?RegExp("_ga_"+userMeasurementId.replace(/^G-/,"")+"="):/_ga_[A-Z0-9]{8,}=/,r=0;r<e.length;r++){var i=e[r].trim();if(t.test(i))return console.log("GA4 cookie found:",i),i.split("=")[1].split(".")[2]}return console.log("GA4 cookie not found"),"Not Available"}function updateSiteVisitPixel(e,t,r){try{if(!pixelFired&&"page_view"===r.ga_event){var i=window.location.protocol,o=window.location.href,a=document.createElement("IMG"),l=i+"//tvspix.com/t.png?&t="+Date.now()+"&l=${outcomeLid}&u3="+encodeURIComponent(o)+"&u17="+encodeURIComponent(e||"")+"&u18="+encodeURIComponent(t||"")+"&u19="+encodeURIComponent(JSON.stringify(r));a.setAttribute("src",l),a.setAttribute("alt",""),a.style.display="none",a.style.position="fixed",document.body.appendChild(a),pixelFired=!0,console.log("Site visit pixel updated successfully.")}}catch(n){console.error("Error updating site visit pixel:",n)}}function isGoogleAnalyticsResource(e){return 0===e.indexOf("https://www.google-analytics.com/g/collect?")||0===e.indexOf("https://analytics.google.com/g/collect?")}function getCookie(e){var t=RegExp("(?:(?:^|.*;\\s*)"+e+"\\s*\\=\\s*([^;]*).*$)|^.*$");return document.cookie.replace(t,"$1")}function extractGAInfo(e){var t=new URL(e),r=new URLSearchParams(t.search),i=getCookie("_ga"),o=i?i.split(".").slice(-2).join("."):"Not Available",a=getGA4SessionId();return{ga_script_loaded:"1",ga_measurement_id:userMeasurementId||r.get("tid")||"Not Available",ga_sid:a,ga_event:r.get("en")||"Not Available",ga_timestamp:r.get("_p")?r.get("_p")+"000":"Not Available",ga_pageurl:r.get("dl")?decodeURIComponent(r.get("dl")):"Not Available",ga_cid:o,ga_ref:r.get("dr")?decodeURIComponent(r.get("dr")):"Not Available"}}function logResourceDetails(e){if(e&&e.name&&isGoogleAnalyticsResource(e.name))try{var t=extractGAInfo(e.name);console.log("Google Analytics Resource Details:",t),updateSiteVisitPixel(t.ga_cid,t.ga_ref,t),console.log("------------------------")}catch(r){console.error("Error logging Google Analytics resource details:",r)}}function logResources(){if(performance&&performance.getEntriesByType)try{var e=performance.getEntriesByType("resource");console.log("Total Resources Loaded:",e.length);for(var t=0;t<e.length;t++)logResourceDetails(e[t])}catch(r){console.error("Error logging resources:",r)}else console.warn("Performance API not supported. Unable to log resources.")}function fireEventAfterDelay(){setTimeout(function(){if(!pixelFired){var e={ga_script_loaded:"0",ga_measurment_id:"Not Available",ga_sid:"Not Available",ga_event:"Not Available",ga_timestamp:"Not Available",ga_pageurl:"Not Available",ga_cid:"Not Available",ga_ref:"Not Available"};updateSiteVisitPixel("",e.ga_ref,e),console.log("Event fired after 1 second."),pixelFired=!0}},1e3)}if("undefined"!=typeof PerformanceObserver)try{new PerformanceObserver(function(e){for(var t=e.getEntries(),r=0;r<t.length;r++){var i=t[r];if(logResourceDetails(i),isGoogleAnalyticsResource(i.name)){var o=extractGAInfo(i.name);console.log("Google Analytics resource loaded. Firing pixel again."),updateSiteVisitPixel(o.ga_cid,o.ga_pageurl,o)}}}).observe({entryTypes:["resource"]}),console.log("PerformanceObserver created and observing resource timing entries.")}catch(e){console.error("Error creating PerformanceObserver:",e)}else console.warn("PerformanceObserver not supported. Unable to observe resource timing entries.");window.addEventListener("load",function(){logResources(),fireEventAfterDelay()});
</script>
`

export function generateGA4Script(measurementId, outcomeLid) {
  return `
var pixelFired = false;

var userMeasurementId = "${measurementId}"

function getGA4SessionId() {
  var cookies = document.cookie.split(';');
  var cookiePattern = userMeasurementId ?
    new RegExp('_ga_' + userMeasurementId.replace(/^G-/, '') + '=') :
    /_ga_[A-Z0-9]{8,}=/;

  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].trim();
    if (cookiePattern.test(cookie)) {
      console.log('GA4 cookie found:', cookie);
      return cookie.split('=')[1].split('.')[2];
    }
  }
  console.log('GA4 cookie not found');
  return 'Not Available';
}

function updateSiteVisitPixel(cid, referrerURL, gaInfo) {
  try {
    if (!pixelFired && gaInfo.ga_event === 'page_view') {
      var protocol = window.location.protocol;
      var href = window.location.href;
      var pixel = document.createElement("IMG");
      var pixelUrl = protocol + "//tvspix.com/t.png?&t=" + Date.now() + "&l=${outcomeLid}&u3=" + encodeURIComponent(href) + "&u17=" + encodeURIComponent(cid || '') + "&u18=" + encodeURIComponent(referrerURL || '') + "&u19=" + encodeURIComponent(JSON.stringify(gaInfo));
      pixel.setAttribute("src", pixelUrl);
      pixel.setAttribute("alt", "");
      pixel.style.display = "none";
      pixel.style.position = "fixed";
      document.body.appendChild(pixel);
      pixelFired = true;
      console.log('Site visit pixel updated successfully.');
    }
  } catch (error) {
    console.error('Error updating site visit pixel:', error);
  }
}

function isGoogleAnalyticsResource(resourceName) {
  return resourceName.indexOf('https://www.google-analytics.com/g/collect?') === 0 || resourceName.indexOf('https://analytics.google.com/g/collect?') === 0;
}

// Get regular _ga cookie for CID
function getCookie(name) {
  var regex = new RegExp('(?:(?:^|.*;\\s*)' + name + '\\s*\\=\\s*([^;]*).*$)|^.*$');
  console.warn('document.cookie:', document.cookie); // Log document.cookie
  const result = document.cookie.replace(regex, "$1");
  return result;
}

function extractGAInfo(resourceName) {
  var url = new URL(resourceName);
  var params = new URLSearchParams(url.search);

  var gaCookie = getCookie('_ga');
  console.warn('hello', gaCookie)
  var gaCid = gaCookie ? gaCookie.split('.').slice(-2).join(".") : '';
  var gaSid = getGA4SessionId();

  return {
    ga_script_loaded: "1",
    ga_measurement_id: userMeasurementId || params.get('tid') || 'Not Available',
    ga_sid: gaSid,
    ga_event: params.get('en') || 'Not Available',
    ga_timestamp: params.get('_p') ? params.get('_p') + '000' : 'Not Available',
    ga_pageurl: params.get('dl') ? decodeURIComponent(params.get('dl')) : 'Not Available',
    ga_cid: gaCid || params.get('cid') || 'Not Available',
    ga_ref: params.get('dr') ? decodeURIComponent(params.get('dr')) : 'Not Available',
  };
}

function logResourceDetails(resource) {
  if (resource && resource.name && isGoogleAnalyticsResource(resource.name)) {
    try {
      var gaInfo = extractGAInfo(resource.name);
      console.log('Google Analytics Resource Details:', gaInfo);
      updateSiteVisitPixel(gaInfo.ga_cid, gaInfo.ga_ref, gaInfo);
      console.log('------------------------');
    } catch (error) {
      console.error('Error logging Google Analytics resource details:', error);
    }
  }
}

function logResources() {
  if (performance && performance.getEntriesByType) {
    try {
      var resources = performance.getEntriesByType('resource');
      console.log('Total Resources Loaded:', resources.length);
      for (var i = 0; i < resources.length; i++) {
        logResourceDetails(resources[i]);
      }
    } catch (error) {
      console.error('Error logging resources:', error);
    }
  } else {
    console.warn('Performance API not supported. Unable to log resources.');
  }
}

function fireEventAfterDelay() {
  setTimeout(function () {
    if (pixelFired) {
      return
    }
    var gaInfo = {
      ga_script_loaded: "0",
      ga_measurment_id: 'Not Available',
      ga_sid: 'Not Available',
      ga_event: 'Not Available',
      ga_timestamp: 'Not Available',
      ga_pageurl: 'Not Available',
      ga_cid: 'Not Available',
      ga_ref: 'Not Available'
    };
    updateSiteVisitPixel('', gaInfo.ga_ref, gaInfo);
    console.log('Event fired after 1 second.');
    pixelFired = true;
  }, 1000);
}

if (typeof PerformanceObserver !== 'undefined') {
  try {
    var observer = new PerformanceObserver(function (list) {
      var entries = list.getEntries();
      for (var i = 0; i < entries.length; i++) {
        var entry = entries[i];
        logResourceDetails(entry);
        if (isGoogleAnalyticsResource(entry.name)) {
          var gaInfo = extractGAInfo(entry.name);
          console.log('Google Analytics resource loaded. Firing pixel again.');
          updateSiteVisitPixel(gaInfo.ga_cid, gaInfo.ga_pageurl, gaInfo);
        }
      }
    });
    observer.observe({ entryTypes: ['resource'] });
    console.log('PerformanceObserver created and observing resource timing entries.');
  } catch (error) {
    console.error('Error creating PerformanceObserver:', error);
  }
} else {
  console.warn('PerformanceObserver not supported. Unable to observe resource timing entries.');
}

window.addEventListener('load', function () {
  logResources();
  fireEventAfterDelay();
});

// Expose functions for testing
// This happens automatically in the browser
window.extractGAInfo = extractGAInfo;
window.getGA4SessionId = getGA4SessionId;
`;
}

export async function getGA4Script({ measurementId, outcomeLid }) {
  const script = generateGA4Script(measurementId, outcomeLid);

  try {
    const result = await minify(script);
    return result.code;
  } catch (error) {
    console.error('Error minifying script:', error);
    return null;
  }
}


